// Menu drawer main

function kaDisableRootScroll() {
  $(".ka_header_tab_body .simplebar-content-wrapper").css("overflow", "hidden");
}

function kaEnableRootScroll() {
  $(".ka_header_tab_body .simplebar-content-wrapper").css("overflow", "");
}

$(document).ready(function () {
  $(".ka_bars").click(function () {
    $(".ka_header_tab").addClass("ka_header_tab_tjs");
    $("body").addClass("ka_body_hidden");
    $(".ka_header_overlay").addClass("ka_header_overlay_js");
  });

  $(".ka_header_tab_cross, .ka_header_overlay").click(function () {
    $(".ka_header_tab").removeClass("ka_header_tab_tjs");
    $("body").removeClass("ka_body_hidden");
    $(".ka_header_overlay").removeClass("ka_header_overlay_js");
    $(".ka_hp_menu_tab_1st").removeClass("active").hide();
    $(".ka_hp_menu_tab_1st").removeClass("ka_header_tab_scroll");
    $(".ka_hr_pt_button_tjs").removeClass("selected");
    $(".ka_hp_menu_tab_2nd").removeClass("active").hide();
    $(".ka_hp_menu_tab_2nd").removeClass("ka_header_tab_scroll");
    $(".ka_menu_1st_c_a_tjs").removeClass("selected");
    $(".ka_hp_menu_tab_3rd").removeClass("active").hide();
    $(".ka_hp_menu_tab_3rd").removeClass("ka_header_tab_scroll");
    $(".ka_menu_2nd_c_a_tjs").removeClass("selected");
    $(".ka_header_tab").addClass("ka_header_tab_scroll");
    kaEnableRootScroll();
  });
});

// Menu drawer main-1-main

$(document).ready(function () {
  $(".ka_hr_pt_button_tjs").click(function () {
    if ($(this).next().hasClass("active")) {
      $(this).next().removeClass("active").hide();
      $(this).next().removeClass("ka_header_tab_scroll");
      $(this).removeClass("selected");
      kaEnableRootScroll();
    } else {
      $(".ka_hp_menu_tab_1st").removeClass("active").hide();
      $(".ka_hp_menu_tab_1st").removeClass("ka_header_tab_scroll");
      $(".ka_hr_pt_button_tjs").removeClass("selected");
      $(this).next(".ka_hp_menu_tab_1st").addClass("active").show();
      $(this).next(".ka_hp_menu_tab_1st").addClass("ka_header_tab_scroll");
      $(this).addClass("selected");
      kaDisableRootScroll();
    }
    $(".ka_header_tab").removeClass("ka_header_tab_scroll");
  });

  $(".ka_ht_button_1st_tjs").click(function () {
    $(".ka_hp_menu_tab_1st").removeClass("active").hide();
    $(".ka_hp_menu_tab_1st").removeClass("ka_header_tab_scroll");
    $(".ka_hr_pt_button_tjs").removeClass("selected");
    $(".ka_header_tab").addClass("ka_header_tab_scroll");
    kaEnableRootScroll();
  });
});

// Menu drawer 1-2-1

$(document).ready(function () {
  $(".ka_menu_1st_c_a_tjs").click(function () {
    if ($(this).next().hasClass("active")) {
      $(this).next().removeClass("active").hide();
      $(this).next().removeClass("ka_header_tab_scroll");
      $(this).removeClass("selected");
    } else {
      $(".ka_hp_menu_tab_2nd").removeClass("active").hide();
      $(".ka_hp_menu_tab_2nd").removeClass("ka_header_tab_scroll");
      $(".ka_menu_1st_c_a_tjs").removeClass("selected");
      $(this).next(".ka_hp_menu_tab_2nd").addClass("active").show();
      $(this).next(".ka_hp_menu_tab_2nd").addClass("ka_header_tab_scroll");
      $(this).addClass("selected");
    }
    $(".ka_hp_menu_tab_1st").removeClass("ka_header_tab_scroll");
  });

  $(".ka_ht_button_2nd_tjs").click(function () {
    $(".ka_hp_menu_tab_2nd").removeClass("active").hide();
    $(".ka_menu_1st_c_a_tjs").removeClass("selected");
    $(".ka_hp_menu_tab_1st").addClass("ka_header_tab_scroll");
  });
});

// Menu drawer 2-3-2

$(document).ready(function () {
  $(".ka_menu_2nd_c_a_tjs").click(function () {
    if ($(this).next().hasClass("active")) {
      $(this).next().removeClass("active").hide();
      $(this).next().removeClass("ka_header_tab_scroll");
      $(this).removeClass("selected");
    } else {
      $(".ka_hp_menu_tab_3rd").removeClass("active").hide();
      $(".ka_hp_menu_tab_3rd").removeClass("ka_header_tab_scroll");
      $(".ka_menu_2nd_c_a_tjs").removeClass("selected");
      $(this).next(".ka_hp_menu_tab_3rd").addClass("active").show();
      $(this).next(".ka_hp_menu_tab_3rd").addClass("ka_header_tab_scroll");
      $(this).addClass("selected");
    }
    $(".ka_hp_menu_tab_2nd").removeClass("ka_header_tab_scroll");
  });

  $(".ka_ht_button_3rd_tjs").click(function () {
    $(".ka_hp_menu_tab_3rd").removeClass("active").hide();
    $(".ka_menu_2nd_c_a_tjs").removeClass("selected");
    $(".ka_hp_menu_tab_2nd").addClass("ka_header_tab_scroll");
  });
});

// Go to previous page

$(document).ready(function () {
  $(".ka_sb_button_icon_djs").click(function () {
    window.history.back();
  });
});

// Preventing from refreshing page

document.addEventListener("DOMContentLoaded", function () {
  let firstLevelItems = document.querySelectorAll(".ka_menu_1st_c_a_tjs");

  firstLevelItems.forEach((item) => {
    item.addEventListener("click", function (e) {
      e.preventDefault();
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  let secondLevelItems = document.querySelectorAll(".ka_menu_2nd_c_a_tjs");

  secondLevelItems.forEach((item) => {
    item.addEventListener("click", function (e) {
      e.preventDefault();
    });
  });
});
